import { Box, List, Text, DateInput as GrommetDateInput } from 'grommet';
import {startOfDay, parseISO, formatISO, format} from 'date-fns';
import {addNDays, formatNumericDate} from '../../utils/dates';
import React, { useState } from 'react';
import { SCHEDULE_INVOICE_PRESET_DATES } from '../../constants/Dates';
import { snakeCase } from '../../utils/string';
import Button from '../Button';
import Modal from '../Modal';

const ScheduleSendModal = ({onClose, onSubmit, isLoading}) => {
    const [selectedDate, setSelectedDate] = useState(SCHEDULE_INVOICE_PRESET_DATES[0].date); // default is tomorrow
    const [activeMenuItem, setActiveMenuItem] = useState(0);

    return (
        <Modal
            onSubmit={isLoading ? undefined : () => {
                const date = startOfDay(parseISO(selectedDate));
                onSubmit(formatISO(date));
            }}
            ctaText={isLoading ? "Scheduling..." : "Schedule invoice"}
            onClose={isLoading ? () => {} : onClose}
            title={"Pick invoice issue date"}
            footerProps={{pad: "0"}}
            contentProps={{pad: {vertical: 'small', horizontal: 'xsmall'}}}
            hideDeepLink>
            <Box direction="row" gap="xsmall">
                <Box border={{side: 'right'}}>
                    <List
                        data={SCHEDULE_INVOICE_PRESET_DATES}
                        pad={{right: 'medium'}}
                        margin={{left: 'xxsmall', top: 'xsmall'}}
                        gap="xsmall"
                    >
                        {(item, index) => (
                            <Box background={activeMenuItem === index ? "brand" : "none"} round="xsmall">
                                <Button
                                    event={{section: 'schedule_send_invoice_modal', element: 'preset_date', description: snakeCase(item.label)}} 
                                    label={(
                                        <Box 
                                            round="xsmall" 
                                            fill="horizontal">
                                            <Text textAlign="start" weight={activeMenuItem === index ? 600 : 400}>{item.label}</Text>
                                        </Box>
                                    )}
                                    onClick={() => {
                                        setSelectedDate(item.date);
                                        setActiveMenuItem(index);
                                    }}
                                />
                            </Box>
                        )}
                    </List>
                </Box>
                <Box>
                    <GrommetDateInput
                        inline
                        value={selectedDate}
                        onChange={({ value }) => {
                            setSelectedDate(value);
                            // check if user selected any pre-existing menu item
                            const formattedSelectedValue = format(parseISO(value),'yyyy-MM-dd')
                            const matchingMenuItem = SCHEDULE_INVOICE_PRESET_DATES.findIndex(item => item.date === formattedSelectedValue)
                            setActiveMenuItem(matchingMenuItem > -1 ? matchingMenuItem : undefined);
                        }}
                        calendarProps={{
                            alignSelf: "center",
                            daysOfWeek: true,
                            bounds: [
                                formatNumericDate(addNDays(new Date(), 1), '-'),
                                '2525-01-01'
                            ],
                            animate: false,
                            showAdjacentDays: "trim"
                        }}
                    />
                </Box>
            </Box>
        </Modal>
    );
};

export default ScheduleSendModal;